<template>
    <div>
        <v-toolbar flat style="background-color: transparent" class="mt-1 d-flex justify-center">
            <div class="d-flex align-center">
                <v-btn
                    icon
                    @click="infoDialog = true"
                >
                    <v-icon>mdi-information</v-icon>

                    <v-dialog v-model="infoDialog" width="500">
                        <v-card width="500" class="pa-4">
                            <v-card-title class="d-flex justify-center mb-4">
                                <h1 class="font-weight-light">Información</h1>
                            </v-card-title>
                            <v-card-text style="text-align: justify; text-justify: inter-word;">
                                <p style="font-size: 1.3em; color: grey;">
                                    En este mapa se muestran las ubicaciones de los fichajes realizados a través de la aplicación.
                                    Esta información solamente es visible para los gerentes y el propio usuario. La ubicación 
                                    solamente se recoge en el momento de fichar y no se almacena en ningún otro dato relativo.
                                    La precisión de la ubicación depende del propio dispositivo móvil y de la cobertura de la zona,
                                    por lo que la localización puede tener cierto margen de error.
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-btn>
                <v-btn-toggle v-model="toggle_exclusive" color="primary" mandatory>
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                            >
                                <div>
                                    <p class="mb-n1">Filtrar</p>
                                    <small class="mt-n1">{{date}}</small>
                                </div>
                                <v-icon right>mdi-calendar</v-icon>
                            </v-btn>
                        </template>
                        <v-date-picker
                            v-model="date"
                            @input="menu2 = false"
                            :allowed-dates="allowedDates"
                        ></v-date-picker>
                    </v-menu>

                    <v-btn>
                        Todos
                        <v-icon right>mdi-map-marker</v-icon>
                    </v-btn>
                </v-btn-toggle>
            </div>
        </v-toolbar>
        <v-card elevation="8" class="ma-4 pa-4">
            <v-menu v-if="!date && getLegend.length" transition="scroll-y-transition">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        absolute
                        top
                        right
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon>mdi-map-legend</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                        v-for="(item, index) in getLegend"
                        :key="index"
                        @click="highLight(item)"
                    >
                        <div>
                            <v-icon :color="item.color" left>mdi-map-marker</v-icon>
                            <span class="overline">{{ item.message }}</span>
                        </div>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                        <span class="overline">Tiempo de resaltado</span>
                    </v-list-item>
                    <v-list-item class="mt-6" @click.stop="">
                        <v-list-item-content>
                            <div style="position: absolute; width: 80%;">
                                <v-slider
                                    v-model="timeout"
                                    step="500"
                                    min="500"
                                    max="2000"
                                    ticks="always"
                                    thumb-label="always"
                                    :thumb-color="timeout > 1000 ? 'green' : 'red'"
                                ></v-slider>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
            <MapBoxViewVue
                :geoLatLng="filterByDate"
                :fullscreen="true"
                :customMarkers="true"
                :moveMarker="false"
            />
        </v-card>
    </div>
</template>


<script>
import { mapState } from 'vuex'
import MapBoxViewVue from '@/components/ComercialTeletrabajo/CoverageAvatelView/MapBoxView.vue';

export default {
    name: 'PunchInGeo',
    data: () => ({
        toggle_exclusive: 1,
        menu2: false,
        date: null,
        geoLatLng: [],
        infoDialog: false,
        timeout: 1500
    }),
    components: {
        MapBoxViewVue
    },
    computed: {
        getLegend(){
            const datePattern = /\d{4}-\d{2}-\d{2}/g;
            let noRepeat = []
            for (let i = 0; i < this.geoLatLng.length; i++) {
                const element = this.geoLatLng[i];
                if (!noRepeat.some(l => l.color === element.color)){
                    noRepeat.push(element)
                }
            }

            return noRepeat
            .map(l => {
                return {
                    color: l.color,
                    message: l.message.match(datePattern)
                            .filter((item, index, self) => self.indexOf(item) === index)
                            .join(', ')
                }
            })
        },
        filterByDate(){
            return this.geoLatLng.filter(l => this.date ? l.message.includes(this.date) : l)
        },
        ...mapState('punchIn', ['punches', 'isLoading']),
    },
    methods: {
        getLocations() {
            return  this.punches.map(p => {
                let color = this.getRandColor();
                return Object.values(p.punches).map(segment => {
                    let loc = []
                    if (String(segment?.IN?.location) == String(segment?.OUT?.location)){
                        let inLoc = {
                            loc: [segment.IN.location.longitude, segment.IN.location.latitude],
                            message: `Entrada ${p.date}, ${segment.IN.time} - Salida ${p.date}, ${segment.OUT.time}`,
                            color: color,
                        }
                        loc.push(inLoc)
                    } else {
                        if (segment?.IN?.location){
                            let inLoc = {
                                loc: [segment.IN.location.longitude, segment.IN.location.latitude],
                                message: `Entrada ${p.date}, ${segment.IN.time}`,
                                color: color,
                            }
                            loc.push(inLoc)
                        }
                        if (segment?.OUT?.location){
                            let outLoc = {
                                loc: [segment.OUT.location.longitude, segment.OUT.location.latitude],
                                message: `Salida ${p.date}, ${segment.OUT.time}`,
                                color: color,
                            }
                            loc.push(outLoc)
                        }
                    }

                    return loc
                })
            })
            .flat(2)
        },
        allowedDates(val){
            return this.punches.some(d => d.date === val);
        },
        getRandColor(){
            const hue = Math.floor(Math.random() * 360);
            const saturation = 80; // Fixed high saturation (adjust as needed)
            const lightness = 50; // Fixed lightness (adjust as needed)

            return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
        },
        highLight(item){
            const elements = document.querySelectorAll(`[fill="${item.color}"]`)

            elements.forEach(e => {
                e.parentElement.parentElement.style.transition = "all 0.5s ease-in";
                e.parentElement.parentElement.style.transform = "scale(3)";
            })
            setTimeout(() => {
                elements.forEach(e => {
                    e.parentElement.parentElement.style.transition = "all 0.5s ease-out";
                    e.parentElement.parentElement.style.transform = "scale(1)";
                })
            }, this.timeout)
        }
    },
    watch: {
        toggle_exclusive(val){
            if (val === 1){
                this.date = null
            }
        },
        menu2(val){
            if (!val && !this.date){
                this.toggle_exclusive = 1
            }
        },
        punches(val){
            this.geoLatLng = this.getLocations()
        }
    },
    created() {
        this.geoLatLng = this.getLocations()
    },
}
</script>
